import { render, staticRenderFns } from "./MemberDelete.vue?vue&type=template&id=065169b1&scoped=true&"
import script from "./MemberDelete.vue?vue&type=script&lang=js&"
export * from "./MemberDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065169b1",
  null
  
)

export default component.exports